import React from 'react';
import { Link } from 'react-router-dom';

// LV1 Group brand portfolio for marquee
const lv1Brands = [
  { name: 'Hurley', slug: 'hurley' },
  { name: 'Nicole Miller', slug: 'nicole-miller' },
  { name: 'Tahari', slug: 'tahari' },
  { name: 'Catherine Malandrino', slug: 'catherine-malandrino' },
  { name: 'Taryn Rose', slug: 'taryn-rose' },
  { name: 'Jason Wu', slug: 'jason-wu' },
  { name: 'Ann Taylor', slug: 'ann-taylor' },
  { name: 'Cloud Air', slug: 'cloud-air' },
  { name: 'Sunday Walks', slug: 'sunday-walks' },
  { name: 'Serene Island', slug: 'serene-island' },
  { name: 'Arctic Plunge', slug: 'arctic-plunge' },
  { name: 'Modern Rebel', slug: 'modern-rebel' },
];

const LogoMarquee = () => {
  // Duplicate brands for seamless infinite loop
  const duplicatedBrands = [...lv1Brands, ...lv1Brands];

  return (
    <section className="bg-transparent py-10 overflow-hidden relative z-10">
      {/* Edge fade masks */}
      <div
        className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{
          background: 'linear-gradient(to right, #0a0a0a 0%, transparent 100%)',
        }}
      />
      <div
        className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{
          background: 'linear-gradient(to left, #0a0a0a 0%, transparent 100%)',
        }}
      />

      <div className="relative">
        <div className="flex animate-marquee">
          {duplicatedBrands.map((brand, index) => (
            <Link
              key={index}
              to={`/brands/${brand.slug}`}
              className="flex-shrink-0 mx-12 flex items-center justify-center cursor-pointer group"
            >
              <span
                className="text-white/35 text-[15px] font-light tracking-[0.15em] uppercase transition-all duration-300 group-hover:text-white/60"
                style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
              >
                {brand.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
